import React from "react";

interface AppSwitcherIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const AppSwitcherIcon: React.FC<AppSwitcherIconProps> = ({
  width = 16,
  height = 16,
  fill = "currentColor",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1.01C0 0.451 0.443 0 1.01 0H2.99C3.549 0 4 0.443 4 1.01V2.99C4 3.549 3.557 4 2.99 4H1.01C0.451 4 0 3.557 0 2.99V1.01ZM0 7.01C0 6.452 0.443 6 1.01 6H2.99C3.548 6 4 6.443 4 7.01V8.99C4 9.549 3.557 10 2.99 10H1.01C0.451 10 0 9.557 0 8.99V7.01ZM6 1.01C6 0.452 6.443 0 7.01 0H8.99C9.548 0 10 0.443 10 1.01V2.99C10 3.549 9.557 4 8.99 4H7.01C6.451 4 6 3.557 6 2.99V1.01ZM6 7.01C6 6.452 6.443 6 7.01 6H8.99C9.548 6 10 6.443 10 7.01V8.99C10 9.548 9.557 10 8.99 10H7.01C6.452 10 6 9.557 6 8.99V7.01ZM12 1.01C12 0.452 12.443 0 13.01 0H14.99C15.548 0 16 0.443 16 1.01V2.99C16 3.549 15.557 4 14.99 4H13.01C12.451 4 12 3.557 12 2.99V1.01ZM12 7.01C12 6.452 12.443 6 13.01 6H14.99C15.548 6 16 6.443 16 7.01V8.99C16 9.548 15.557 10 14.99 10H13.01C12.452 10 12 9.557 12 8.99V7.01ZM0 13.01C0 12.452 0.443 12 1.01 12H2.99C3.548 12 4 12.443 4 13.01V14.99C4 15.549 3.557 16 2.99 16H1.01C0.451 16 0 15.557 0 14.99V13.01ZM6 13.01C6 12.452 6.443 12 7.01 12H8.99C9.548 12 10 12.443 10 13.01V14.99C10 15.548 9.557 16 8.99 16H7.01C6.452 16 6 15.557 6 14.99V13.01ZM12 13.01C12 12.452 12.443 12 13.01 12H14.99C15.548 12 16 12.443 16 13.01V14.99C16 15.548 15.557 16 14.99 16H13.01C12.452 16 12 15.557 12 14.99V13.01Z"
      fill={fill}
    />
  </svg>
);

export default AppSwitcherIcon;
